// extracted by mini-css-extract-plugin
export default {"list":"ImportConnectionsCSV_list__wGn+b","link":"ImportConnectionsCSV_link__achHK"};